'use client';
import React, { Suspense } from 'react';
import AuthScreen from './components/AuthScreen';

export default function AuthPage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-[#0F1B2D] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#00C9A7] border-t-transparent rounded-full animate-spin" /></div>}>
      <AuthScreen />
    </Suspense>
  );
}